import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import TableControl from 'pages/parts/TableControl'

import { PGET, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDateBackend, findFromArrayById, formatDate, formatDateWithTime } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"
import { useNavigate } from "react-router-dom"

function Index() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const reduxAccount = useSelector(state => state.account)

	const [poses, setPoses] = useState([])
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [modalTableControl, setModalTableControl] = useState(false)
	const [openModal, setOpenModal] = useState(false)
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [URL, setURL] = useState("");
	const [pageCount, setPageCount] = useState(0)
	const reduxSettings = useSelector(state => state.settings)
	const [dailyData, setDailyData] = useState([])
	const [filterData, setFilterData] = useState({
		posId: reduxAccount.posId,
		dateBalance: null,
		productCategoryId: null,
		currencyId: 1,
		search: null,
		startDate: formatDateBackend(new Date()),
		endDate: formatDateBackend(new Date())
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-cashier-sales-all',
		response: null
	})
	const [data, setData] = useState([])

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		var filterUrl = "/services/web/api/report-cashier-sales-all"
		var urlParams = ""
		checkFilter()

		if (filterData.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.organizationId)
			urlParams += returnSign(urlParams) + 'organizationId=' + filterData.organizationId
		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if ("/services/web/api/report-cashier-sales-all" + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection === ',asc' ? filterDataCopy.tableSortDirection = ',desc' : filterDataCopy.tableSortDirection = ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort

			setFilterData(filterDataCopy)
			urlParams += returnSign(urlParams) + 'sort=' + tableSort + filterDataCopy.tableSortDirection
		}
		let WithoutParams = filterUrl

		filterUrl = filterUrl + urlParams
		setURL(filterUrl);

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-cashier-sales-excel" + urlParams + returnSign(filterUrl)

			var excelHeaders = [[
				t('POS'), t('DATE'), t('CASHBOX'), t('CASHIER'), t('AMOUNT'), t('PAID'), t('CHANGE'), t('DISCOUNT'),
				t('DEBT'), t('RETURN'), 'Loyalty', 'Loyalty' + t('AMOUNT'), t('CASH'), t('TERMINAL'), 'CLICK', 'PAYME'
			]]
			const response = await GET(filterUrl)
			for (let i = 0; i < response.length; i++) {
				var excelItems = []
				excelItems.push(response[i].posName)
				excelItems.push(response[i].chequeDate)
				excelItems.push(response[i].cashboxName)
				excelItems.push(response[i].cashierName)
				excelItems.push(response[i].totalAmount)
				excelItems.push(response[i].paid)
				excelItems.push(response[i].change)
				excelItems.push(response[i].discount)
				excelItems.push(response[i].debtOut)
				excelItems.push(response[i].returnedAmount)
				excelItems.push(response[i].ugetBonus)
				excelItems.push(response[i].ugetPaid)
				excelItems.push(response[i].cash)
				excelItems.push(response[i].card)
				excelItems.push(response[i].click)
				excelItems.push(response[i].payme)
				excelHeaders.push(excelItems)
			}
			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('CASHIERS') + ".xlsx");
		} else {
			const response = await PGET(WithoutParams, { ...filterData, size: ItemsPerPage }
				, { loader: true })
			if (response) {
				setData(response.data)

				// setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				// setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

			}
		}

		setDropdownIsOpen(false)
	}

	function resetFilter() {
		setFilterData({
			posId: poses[0].id,
			dateBalance: null,
			productCategoryId: null,
			currencyId: 1,
			search: '',
		})
		setFilterDataExist(false)
		getData()
	}

	async function getData() {
		const response = await PGET("/services/web/api/report-cashier-sales-all", { ...filterData }, { loader: true })
		if (response) {
			setData(response.data)
			let res = await groupByUserLoginWithDates(response.data)
			console.log(res);
		}
	}

	function checkFilter() {
		if (
			filterData.posId === null &&
			filterData.dateBalance === null &&
			filterData.currencyId === 1 &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			setPoses(response)
			searchWithFilter(false)
		}
	}

	useEffect(() => {
		groupByUserLoginWithDates(data)
	}, [data])

	// async function paginate(data) {
	// 	const response = await PGET(URL, { ...filterData, page: data.selected, size: ItemsPerPage }, { loader: true })
	// 	setFilterData({ ...filterData, page: data.selected })
	// 	setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
	// 	setData(response.data);
	// }


	useEffect(() => {
		getPoses()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	function redirectToInner(item) {
		// dispatch(SET_REPORT_SELECTED_CLIENT(item))
		navigate(`/report/cashier/`, {
			state: { cashier: item.detailsByDate, filterData: filterData }
		});

	}

	function groupByUserLoginWithDates(data) {
		const grouped = {};

		data.forEach(item => {
			const login = item.userLogin;
			const currency = item.saleCurrencyName || "NO_CURRENCY";
			const chequeDate = item.chequeDate || "NO_DATE";

			// make composite key userLogin + currency
			const key = `${login}_${currency}`;

			if (!grouped[key]) {
				grouped[key] = {
					userLogin: login,
					cashierName: item.cashierName,
					saleCurrencyName: item.saleCurrencyName, // include currency name
					totalAmount: 0,
					paid: 0,
					change: 0,
					discount: 0,
					debtOut: 0,
					debtIn: 0,
					expenseAmount: 0,
					returnedAmount: 0,
					ugetBonus: 0,
					ugetPaid: 0,
					cash: 0,
					card: 0,
					click: 0,
					payme: 0,
					detailsByDate: {},
					hasDailyBalances: false,
					dailyBalances: []
				};
			}

			// group by date inside this currency group
			if (!grouped[key].detailsByDate[chequeDate]) {
				grouped[key].detailsByDate[chequeDate] = [];
			}
			grouped[key].detailsByDate[chequeDate].push(item);

			// accumulate stats
			grouped[key].totalAmount += item.totalAmount || 0;
			grouped[key].paid += item.paid || 0;
			grouped[key].change += item.change || 0;
			grouped[key].discount += item.discount || 0;
			grouped[key].debtOut += item.debtOut || 0;
			grouped[key].debtIn += item.debtIn || 0;
			grouped[key].expenseAmount += item.expenseAmount || 0;
			grouped[key].returnedAmount += item.returnedAmount || 0;
			grouped[key].ugetBonus += item.ugetBonus || 0;
			grouped[key].ugetPaid += item.ugetPaid || 0;
			grouped[key].cash += item.cash || 0;
			grouped[key].card += item.card || 0;
			grouped[key].click += item.click || 0;
			grouped[key].payme += item.payme || 0;

			// daily balances
			if (item.dailyBalances && item.dailyBalances.length > 0) {
				grouped[key].hasDailyBalances = true;
				grouped[key].dailyBalances.push(...item.dailyBalances);
			}
		});

		return Object.values(grouped);
	}


	function SendCashReport(balances) {
		setDailyData(balances);
		setOpenModal(true);
	}



	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('CASHIERS_REPORT')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide" onClick={() => searchWithFilter(true)}>EXCEL</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e); // Update ItemsPerPage
							setFilterData({ ...filterData, page: 0, random: filterData.random + 1 }); // Reset to the first page

						}}
					/>


					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="text-start">{t('CASHIER')}</th>
									<th className="text-end">{t('CURRENCY')}</th>
									<th className="text-end">{t('SALE')}</th>
									<th className="text-end">{t('PAID')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.change) &&
										<th className="text-end">{t('CHANGE')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.discount) &&
										<th className="text-end">{t('DISCOUNT')}</th>
									}
									<th className="text-end">{t('ON_CREDIT')}</th>
									<th className="text-center">{t('CASHBOX_BALANCE')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.debtIn) &&
										<th className="text-end">{t('DEBT_RETURNED')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.expenseAmount) &&
										<th className="text-end">{t('OUT_BALANCE')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.returnedAmount) &&
										<th className="text-end">{t('RETURN')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetBonus) &&
										<th className="text-end">uGet {t('BONUS')}</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetPaid) &&
										<th className="text-end">uGet {t('PAYMENT_2')}</th>
									}
									<th className="text-end">{t('CASH')}</th>
									<th className="text-end">{t('TERMINAL')}</th>
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.click) &&
										<th className="text-end">CLICK</th>
									}
									{(!reduxSettings.tableReport || reduxSettings.tableReport?.payme) &&
										<th className="th-sortable text-end">PAYME</th>
									}
									<th className="th-sortable text-end">
										<i className="uil-setting table-control-icon" onClick={() => setModalTableControl(true)}></i>
									</th>
								</tr>
							</thead>
							<tbody>
								{groupByUserLoginWithDates(data).map((item, index) => {
									// console.log(item);
									return (<>
										<tr key={index}>
											<td className={` text-primary text-start text-nowrap cursor table-first-column-clickable`} onClick={() => redirectToInner(item)}>
												{item.cashierName}
											</td>
											<td className="text-end text-nowrap">{item.saleCurrencyName}</td>
											<td className="text-end text-nowrap">{formatMoney(item.totalAmount)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.paid)}</td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.change) &&
												<td className="text-end text-nowrap">{formatMoney(item.change)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.discount) &&
												<td className="text-end text-nowrap">{formatMoney(item.discount)}</td>
											}
											<td className="text-end text-nowrap">{formatMoney(item.debtOut)}</td>
											<td className="text-end text-nowrap"><button className={`btn btn-secondary ${data?.[index]?.dailyBalances.length > 0 ? 'd-flex' : 'd-none'}`} disabled={data?.[index]?.dailyBalances.length > 0 ? false : true} onClick={(_) => SendCashReport(item.dailyBalances)}>{t('REPORT')}</button></td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.debtIn) &&
												<td className="text-end text-nowrap">{formatMoney(item.debtIn)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.expenseAmount) &&
												<td className="text-end text-nowrap">{formatMoney(item.expenseAmount)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.returnedAmount) &&
												<td className="text-end text-nowrap">{formatMoney(item.returnedAmount)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetBonus) &&
												<td className="text-end text-nowrap">{formatMoney(item.ugetBonus)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.ugetPaid) &&
												<td className="text-end text-nowrap">{formatMoney(item.ugetPaid)}</td>
											}
											<td className="text-end text-nowrap">{formatMoney(item.cash)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.card)}</td>
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.click) &&
												<td className="text-end text-nowrap">{formatMoney(item.click)}</td>
											}
											{(!reduxSettings.tableReport || reduxSettings.tableReport?.payme) &&
												<td className="text-end text-nowrap">{formatMoney(item.payme)}</td>
											}
										</tr>
									</>)
								})}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL REPORT */}
			<Modal show={openModal} animation={false} centered dialogClassName="custom-modal-width" backdrop="static" onHide={() => setOpenModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('REPORT')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th className="text-start">{t('CASHBOX_BALANCE')}</th>
									<th className="text-end">{t('EXPENSE_AMOUNT')}</th>
									<th className="text-end">{t('COMMENT')}</th>
									<th className="text-end">{t('DATE')}</th>
								</tr>
							</thead>
							<tbody>
								{dailyData.length > 0 ? dailyData?.map((item, index) => {
									return (<tr key={index}>
										<td className="text-start text-nowrap">{formatMoney(item.amount)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.expense)}</td>
										<td className="text-end text-nowrap">{item.comment}</td>
										<td className="text-end text-nowrap">{formatDateWithTime(item.createdDate)}</td>
									</tr>
									)
								}
								)
									: <tr><td>No data</td></tr>
								}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL REPORT */}

			{/* MODAL TABLE CONTROL */}
			<TableControl
				modalTableControl={modalTableControl}
				setModalTableControl={setModalTableControl}
				keyName={'tableReport'}>
			</TableControl>
			{/* MODAL TABLE CONTROL */}
		</>
	)
}

export default Index
